module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'suz1w7as',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
